<template>
  <div class="show-no-data">
    <img src="../assets/img/no-data.png" alt="" class="image" :width="imgWidth" :height="imgHeight">
    <span class="no-data-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    imgWidth: {
      type: String,
      default: '180'
    },
    imgHeight: {
      type: String,
      default: '180'
    },
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="scss">
.show-no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  .image {
    display: block;
    margin-bottom: 12px;
  }
  .no-data-text {
    color: $text-color-light;
    line-height: 1;
    font-size: 12px;
  }
}
</style>
